export const MerchantConfigurationActions = Object.freeze({
	MERCHANT_CONFIGURATION_UPDATE: 'merchant_configuration_update'
});
